import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, FormGroup, Label, Input, Row, Col } from "reactstrap";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Item Name is required"),
    category: Yup.string().required("Category is required"),
    itemCode: Yup.string().required("Item Code is required"),
    hsn: Yup.string().required("HSN is required"),
    mrp: Yup.number().required("MRP is required").positive("MRP must be positive"),
    salePrice: Yup.number().required("Sale Price is required").positive("Sale Price must be positive"),
    purchasePrice: Yup.number().required("Purchase Price is required").positive("Purchase Price must be positive"),
    gstRate: Yup.number().required("GST Rate is required").min(0, "Must be at least 0"),
    baseUnit: Yup.string().required("Base Unit is required"),
    baseUnitGst: Yup.number().required("Base Unit GST is required").positive("Base Unit GST must be positive"),
    secondaryUnit: Yup.string().required("Secondary Unit is required"),
    secondaryUnitGst: Yup.number().required("Secondary Unit GST is required").positive("Secondary Unit GST must be positive"),
    secondaryUnitSellingPrice: Yup.number().required("Secondary Unit Selling Price is required").positive("Must be positive"),
    conversionRate: Yup.number().required("Conversion Rate is required").positive("Must be positive"),
    inStock: Yup.number().required("In Stock is required").min(0, "Must be at least 0")
});

export default function AddItemForm({ addItem }) {
    return (
        <Formik
            initialValues={{
                name: "",
                category: "",
                itemCode: "",
                hsn: "",
                mrp: "",
                salePrice: "",
                purchasePrice: "",
                gstRate: "",
                baseUnit: "Pieces",
                baseUnitGst: "",
                secondaryUnit: "",
                secondaryUnitGst: "",
                secondaryUnitSellingPrice: "",
                conversionRate: "",
                inStock: ""
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                addItem(values);
                resetForm();
            }}
        >
            {({ errors, touched, resetForm }) => (
                <Form>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="name">Item Name</Label>
                                <Field
                                    name="name"
                                    as={Input}
                                    type="text"
                                    id="name"
                                    placeholder="Item Name"
                                />
                                {errors.name && touched.name && (
                                    <div className="text-danger">{errors.name}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="category">Category</Label>
                                <Field
                                    name="category"
                                    as="select"
                                    id="category"
                                    className="form-control"
                                >
                                    <option value="">Select Category</option>
                                    <option value="Beverage">Beverage</option>
                                    <option value="Butter">Butter</option>
                                    <option value="Cheese">Cheese</option>
                                    <option value="Chocolate">Chocolate</option>
                                    <option value="Condensed Milk">Condensed Milk</option>
                                    <option value="Cookie">Cookie</option>
                                    <option value="Drink">Drink</option>
                                    <option value="Fresh Cream">Fresh Cream</option>
                                    <option value="Frozen">Frozen</option>
                                    <option value="Ghee">Ghee</option>
                                    <option value="Ice Cream">Ice Cream</option>
                                    <option value="Milk Powder">Milk Powder</option>
                                    <option value="Others">Others</option>
                                    <option value="Paneer">Paneer</option>
                                    <option value="Sweet">Sweet</option>
                                </Field>
                                {errors.category && touched.category && (
                                    <div className="text-danger">{errors.category}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="itemCode">Item Code</Label>
                                <Field
                                    name="itemCode"
                                    as={Input}
                                    type="text"
                                    id="itemCode"
                                    placeholder="Item Code"
                                />
                                {errors.itemCode && touched.itemCode && (
                                    <div className="text-danger">{errors.itemCode}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="hsn">HSN</Label>
                                <Field
                                    name="hsn"
                                    as={Input}
                                    type="text"
                                    id="hsn"
                                    placeholder="HSN"
                                />
                                {errors.hsn && touched.hsn && (
                                    <div className="text-danger">{errors.hsn}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="mrp">MRP</Label>
                                <Field
                                    name="mrp"
                                    as={Input}
                                    type="number"
                                    id="mrp"
                                    placeholder="MRP"
                                />
                                {errors.mrp && touched.mrp && (
                                    <div className="text-danger">{errors.mrp}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="salePrice">Sale Price</Label>
                                <Field
                                    name="salePrice"
                                    as={Input}
                                    type="number"
                                    id="salePrice"
                                    placeholder="Sale Price"
                                />
                                {errors.salePrice && touched.salePrice && (
                                    <div className="text-danger">{errors.salePrice}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="purchasePrice">Purchase Price</Label>
                                <Field
                                    name="purchasePrice"
                                    as={Input}
                                    type="number"
                                    id="purchasePrice"
                                    placeholder="Purchase Price"
                                />
                                {errors.purchasePrice && touched.purchasePrice && (
                                    <div className="text-danger">{errors.purchasePrice}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="gstRate">GST Rate</Label>
                                <Field
                                    name="gstRate"
                                    as={Input}
                                    type="number"
                                    id="gstRate"
                                    placeholder="GST Rate"
                                />
                                {errors.gstRate && touched.gstRate && (
                                    <div className="text-danger">{errors.gstRate}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>

                        <Col md={3}>
                            <FormGroup>
                                <Label for="baseUnit">Base Unit</Label>
                                <Field
                                    name="baseUnit"
                                    as={Input}
                                    type="text"
                                    id="baseUnit"
                                    placeholder="Base Unit"
                                />
                                {errors.baseUnit && touched.baseUnit && (
                                    <div className="text-danger">{errors.baseUnit}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="baseUnitGst">Base Unit GST</Label>
                                <Field
                                    name="baseUnitGst"
                                    as={Input}
                                    type="number"
                                    id="baseUnitGst"
                                    placeholder="Base Unit GST"
                                />
                                {errors.baseUnitGst && touched.baseUnitGst && (
                                    <div className="text-danger">{errors.baseUnitGst}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="secondaryUnit">Secondary Unit</Label>
                                <Field
                                    name="secondaryUnit"
                                    as="select"
                                    id="secondaryUnit"
                                    className="form-control"
                                >
                                    <option value="">Select Secondary Unit</option>
                                    <option value="CART">CART</option>
                                    <option value="BOX">BOX</option>
                                </Field>
                                {errors.secondaryUnit && touched.secondaryUnit && (
                                    <div className="text-danger">{errors.secondaryUnit}</div>
                                )}
                            </FormGroup>

                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="secondaryUnitSellingPrice">Secondary Unit Selling Price</Label>
                                <Field
                                    name="secondaryUnitSellingPrice"
                                    as={Input}
                                    type="number"
                                    id="secondaryUnitSellingPrice"
                                    placeholder="Secondary Unit Selling Price"
                                />
                                {errors.secondaryUnitSellingPrice && touched.secondaryUnitSellingPrice && (
                                    <div className="text-danger">{errors.secondaryUnitSellingPrice}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="secondaryUnit">Secondary Unit GST</Label>
                                <Field
                                    name="secondaryUnitGst"
                                    as={Input}
                                    type="text"
                                    id="secondaryUnitGst"
                                    placeholder="Secondary Unit GST"
                                />
                                {errors.secondaryUnitGst && touched.secondaryUnitGst && (
                                    <div className="text-danger">{errors.secondaryUnitGst}</div>
                                )}
                            </FormGroup>
                        </Col>

                        <Col md={3}>
                            <FormGroup>
                                <Label for="conversionRate">Conversion Rate</Label>
                                <Field
                                    name="conversionRate"
                                    as={Input}
                                    type="number"
                                    id="conversionRate"
                                    placeholder="Conversion Rate"
                                />
                                {errors.conversionRate && touched.conversionRate && (
                                    <div className="text-danger">{errors.conversionRate}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="inStock">In Stock</Label>
                                <Field
                                    name="inStock"
                                    as={Input}
                                    type="number"
                                    id="inStock"
                                    placeholder="In Stock"
                                />
                                {errors.inStock && touched.inStock && (
                                    <div className="text-danger">{errors.inStock}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="justify-content-center mt-4">
                        <Col md="auto">
                            <Button type="submit" color="primary" className="mr-2">
                                Submit
                            </Button>
                            <Button onClick={() => resetForm()} type="button" color="warning">
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/AddItemForm.js